<template>
    <div id="breadcrumb" class="mobileNot">
        <ul>
            <li class="iLine"><router-link to="/">Accueil ></router-link></li>
            <li class="iLine"><router-link to="/dashboard">Catalogue ></router-link></li>
            <li class="iLine"><router-link to="/">Make up ></router-link></li>
            <li class="iLine"><router-link to="/">Lips ></router-link></li>
            <li class="iLine"><router-link to="/">Lipsticks ></router-link></li>
            <li class="iLine"><span>Rouge Lip Tint</span></li>
        </ul>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    props: {
        breadcumb: {
            type: Boolean,
            requiered: true
        }
    }
};
</script>

<style lang="scss" scoped>
#breadcrumb {
    ul {
        font-size: 1.4rem;
        margin: 0;
        padding: 20px 0;
        li {
            a {
                color: #cc0000;
                padding-right: 5px;
                &:hover {
                    color: #b20000;
                    transition: all 0.3s;
                }
            }
            span {
                color: #aaa;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// Breadcrumb.vue?2ce6965a